import React from "react";
import { Alert } from "@material-tailwind/react";
import { FaInfoCircle } from "react-icons/fa";

class CourseLessonErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (process.env.NODE_ENV === "development") {
      console.error("Course lesson page crashed:", error);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="mx-auto mt-8 max-w-3xl px-4">
          <Alert icon={<FaInfoCircle />} color="amber">
            The lesson page hit an unexpected problem. Please reload and try again.
          </Alert>
        </div>
      );
    }

    return this.props.children;
  }
}

export default CourseLessonErrorBoundary;
